import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import * as VueSpinnersCss from "vue-spinners-css";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

Vue.config.productionTip = false;
Vue.use(Toast);

new Vue({
  router,
  store,
  vuetify,
  VueSpinnersCss,
  render: (h) => h(App),
}).$mount("#app");
